import { z } from 'zod';

export const PageSizeSchema = z.union([
  z.literal(15),
  z.literal(25),
  z.literal(50),
  z.literal(100),
  z.literal(250),
  z.literal(500),
]);

export type PageSize = z.infer<typeof PageSizeSchema>;
